import {values, pickBy, mapValues} from 'lodash';
import saveTrack from '../../../utils/gaia/saveTrack';
import {AddSavePromise} from '../../useIsSaved';

// eslint-disable-next-line max-params
export default function removePoint(
    action: RemoveTrackPointAction,
    tracks: {[trackLocalId: string]: Track},
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>,
    project: MapProject,
    addSavePromise: AddSavePromise,
): string {

    const {trackLocalId, pointLocalId} = action;

    const track = tracks[trackLocalId];
    if (!track.isGeometryLoaded) return action.pointLocalId;

    if (values(track.points).length > 1) {
        const trackPoints = track.points;

        const removedPoint = trackPoints[pointLocalId];
        if (removedPoint.properties.isLocallyDeleted) return action.pointLocalId;
        const {order} = removedPoint.properties;

        const nextTrack = {
            ...track,
            points: pickBy(mapValues(trackPoints, (point: TrackPoint) => {
                if (point.properties.isLocallyDeleted) {
                    return point;

                } else if (point.properties.pointLocalId === pointLocalId) {
                    return {
                        ...point,
                        properties: {
                            ...point.properties,
                            isLocallyDeleted: true,
                        }
                    };

                } else if (point.properties.order > order) {
                    return {
                        ...point,
                        properties: {
                            ...point.properties,
                            order: point.properties.order - 1,
                        }
                    };

                } else {
                    return point;
                }

            })) as {[id: string]: TrackPoint}
        };

        setTracks({...tracks, [trackLocalId]: nextTrack});

        if (action.save === true) saveTrack(nextTrack, project, addSavePromise);
    }

    return action.pointLocalId;
}
